export const translations = {
  es: {
    nav: {
      entorno: 'Entorno',
      calidades: 'Calidades',
      pisoPiloto: 'Piso Piloto',
      disponibilidad: 'Disponibilidad',
      promotora: 'Promotora',
      contacto: 'Contacto',
      solicitarInfo: 'Solicitar información',
    },
    hero: {
      title: 'ANETO',
      subtitle: '109 viviendas de obra nueva en Tenerife Sur',
      desc: '32 adosados, 77 apartamentos de 2 y 3 dormitorios, 3 locales comerciales en Llano del Camello, Las Chafiras.',
      ctaPrimary: 'Ver viviendas disponibles',
      ctaSecondary: 'Solicitar información',
      indicators: [
        '109 viviendas',
        '2 y 3 dormitorios',
        'Garaje y trastero',
        'Piscina de 120m² climatizada',
        'Aire acondicionado instalado',
        'Sistema de aerotermia',
        'Armarios empotrados',
        'Certificación A y B',
      ],
    },
    intro: {
      title: 'Tu nuevo hogar en Tenerife Sur',
      p1: 'Aneto ha sido concebido para quienes buscan calidad de vida, comodidad y una ubicación estratégica en el sur de Tenerife.',
      p2: 'Situado en Llano del Camello, junto a Las Chafiras, ofrece una combinación única de tranquilidad residencial y cercanía a todos los servicios.',
      map: 'Ver en Google Maps',
    },
    location: {
      title: 'Todo lo que necesitas a pocos minutos',
      subtitle:
        '"Un enclave residencial consolidado donde puedes hacer tu vida diaria sin necesidad de desplazamientos largos."',
      places: {
        school: 'Colegio Luther King',
        mall: 'Centro Comercial Gran Manzana',
        airport: 'Aeropuerto Tenerife Sur',
        cristianos: 'Los Cristianos',
        adeje: 'Costa Adeje',
        golf: 'Golf del Sur',
        medical: 'Centro médico',
        gym: 'Gimnasios',
        dogPark: 'Parque para perros',
        culture: 'Centro cultural',
        sports: 'Instalaciones deportivas',
        supermarket: 'Supermercados',
      },
    },
    qualities: {
      title: 'Viviendas listas para disfrutar desde el primer día',
      subtitle:
        'Cada vivienda se entrega con un equipamiento completo y acabados de primera calidad, pensados para que solo tengas que preocuparte de disfrutar de tu nuevo hogar.',
      items: [
        'Cocina totalmente equipada',
        'Aire acondicionado instalado',
        'Aerotermia instalada',
        'Armarios empotrados',
        'Iluminación instalada',
        'Plaza de garaje',
        'Trastero privado',
        'Carpinterías de alta calidad',
        'Aislamiento térmico y acústico',
        'Persiana en cada ventana y puerta ventana',
      ],
    },
    amenities: {
      title: 'Piso Piloto Aneto: vive la experiencia antes de decidir',
      subtitle:
        'Espacios diseñados para disfrutar del clima de Tenerife durante todo el año, fomentando el bienestar y la vida en comunidad.',
      features: {
        pool: {
          title: 'Piscina climatizada',
          desc: 'Gran piscina comunitaria de 120m² climatizada mediante bomba de calor aerotérmica para disfrutar todo el año.',
        },
        solarium: {
          title: 'Amplio solárium',
          desc: 'Zonas de descanso y hamacas rodeando la piscina con pavimento antideslizante de primera calidad.',
        },
        gardens: {
          title: 'Zonas ajardinadas',
          desc: 'Paisajismo cuidado con especies autóctonas de bajo consumo hídrico e iluminación ambiental.',
        },
        parking: {
          title: 'Garaje y trasteros',
          desc: 'Plazas de aparcamiento amplias y trasteros privados con preinstalación para carga de vehículos eléctricos.',
        },
      },
    },
    phases: {
      tag: 'Fases del proyecto',
      title: 'Disponibilidad por fases',
      status: {
        sold: 'COMPLETAMENTE VENDIDA',
        available: 'VIVIENDAS DISPONIBLES',
        soon: 'PRÓXIMAMENTE',
      },
      labels: {
        status: 'Estado',
        delivery: 'Entrega',
      },
      buttons: {
        viewProject: 'Ver proyecto',
        viewAvailable: 'Ver viviendas disponibles',
        notify: 'Avisarme del lanzamiento',
      },
      phases: {
        p1: { name: 'Fase 1', delivery: 'Julio 2026' },
        p2: { name: 'Fase 2', delivery: 'Marzo 2027' },
        p3: { name: 'Fase 3', delivery: 'Inicio de 2028' },
        p4: { name: 'Fase 4', delivery: 'Finales de 2028' },
      },
    },
    availability: {
      title: 'Elige tu piso ideal',
      subtitle:
        'Consulta las viviendas disponibles, sus características y precios. Descarga los planos o solicita información sin compromiso.',
      filters: {
        all: 'Todos',
        apartments: 'Apartamentos',
        townhouses: 'Adosados',
      },
      table: {
        type: 'Tipología',
        beds: 'Dormitorios',
        baths: 'Baños',
        area: 'Superficie construida',
        terrace: 'Terraza',
        price: 'Precio',
        plans: 'Planos',
      },
      buttons: {
        viewPlan: 'Ver plano',
        reqPlan: 'Solicitar plano',
      },
      empty: 'No hay viviendas que coincidan con los filtros seleccionados.',
      modal: {
        unit: 'Vivienda',
        close: 'Cerrar plano',
      },
    },
    developer: {
      title: 'Una trayectoria que inspira confianza',
      tabs: {
        promoter: 'Promotora',
        architects: 'Arquitectos',
        energy: 'Calificación energética A',
      },
      learnMore: 'SABER MÁS >',
      architect: {
        name: 'Francisco Javier Álvarez Muñoz',
        p1: 'Francisco Javier Álvarez Muñoz es arquitecto con actividad profesional en Tenerife, donde ha desarrollado proyectos de edificación residencial, rehabilitación y obra nueva, tanto en el ámbito privado como público.',
        p2: 'Su trabajo se centra en una arquitectura contemporánea y funcional, adaptada al entorno insular y con especial atención a la luz, los materiales y la integración paisajística.',
      },
      energy: {
        title: 'Calificación energética',
        p1: 'La promoción Aneto ha sido diseñada con un firme compromiso con la eficiencia energética y el confort de sus residentes.',
        p2: 'Los apartamentos cuentan con Calificación Energética B, mientras que las viviendas adosadas alcanzan la Calificación Energética A, garantizando un menor consumo energético y una reducción de las emisiones de CO₂.',
        p3: 'Todas las viviendas incorporan un sistema individual de aerotermia para la producción de agua caliente sanitaria, una tecnología eficiente y respetuosa con el medio ambiente que aprovecha la energía del aire para reducir el consumo eléctrico.',
        p4: 'Además, las cubiertas de las viviendas adosadas están preparadas para la futura instalación de paneles fotovoltaicos, facilitando la incorporación de energías renovables y contribuyendo a una mayor autosuficiencia energética.',
      },
      pibasa: {
        p1: 'Con más de tres décadas de experiencia en el sector inmobiliario, PIBASA ha participado en el desarrollo de proyectos residenciales, turísticos y hoteleros tanto en Huesca como en Tenerife, consolidando una trayectoria basada en la calidad constructiva, la solvencia empresarial y el cumplimiento de sus compromisos.',
        p2: 'La confianza es uno de los pilares fundamentales de nuestra actividad. Por ello, las cantidades entregadas a cuenta por los compradores cuentan con las garantías legalmente exigidas y están avaladas por Banco Santander, una de las principales entidades financieras de España, ofreciendo la máxima seguridad durante todo el proceso de compra.',
      },
    },
    contact: {
      title: 'Solicita información',
      subtitle:
        'Déjanos tus datos y nuestro equipo comercial se pondrá en contacto contigo a la mayor brevedad posible para resolver todas tus dudas.',
      form: {
        name: 'Nombre completo',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        message: 'Mensaje',
        submit: 'Enviar mensaje',
        sending: 'Enviando...',
        success:
          '¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.',
        namePlaceholder: 'Tu nombre',
        phonePlaceholder: '+34 600 000 000',
        emailPlaceholder: 'tu@email.com',
        messagePlaceholder: '¿En qué podemos ayudarte?',
        typeLabel: 'Tipo de vivienda de interés',
        typePlaceholder: 'Selecciona una opción',
        options: {
          apt2: 'Apartamentos 2 dormitorios',
          apt3: 'Apartamentos 3 dormitorios',
          th2: 'Adosados 2 dormitorios',
          th3: 'Adosados 3 dormitorios',
        },
        rgpd: 'He leído y acepto la política de privacidad y el tratamiento de mis datos personales para recibir información sobre la promoción. *',
        submitBtn: 'QUIERO RECIBIR INFORMACIÓN',
        successTitle: '¡Gracias por tu interés!',
        successDesc:
          'Hemos recibido tu solicitud correctamente. Nos pondremos en contacto contigo muy pronto.',
      },
      info: {
        office: 'Oficina de ventas',
        address: 'C/ Cuescaro, 14, 38639, Las Chafiras, Santa Cruz de Tenerife',
        phone: 'Teléfono',
        email: 'Email',
        schedule: 'Horario',
        hours: 'Lunes a Viernes: 9:00 - 18:00',
      },
    },
    footer: {
      desc: 'Viviendas exclusivas de obra nueva en Llano del Camello, San Miguel de Abona, Tenerife Sur.',
      links: 'Enlaces rápidos',
      legal: 'Legal',
      legalLinks: {
        notice: 'Aviso Legal',
        privacy: 'Política de Privacidad',
        cookies: 'Política de Cookies',
      },
      rights: 'Aneto Residencial. Todos los derechos reservados.',
      disclaimer: 'Las imágenes son orientativas y no contractuales.',
    },
    whatsapp:
      'Hola, me gustaría recibir información sobre el residencial Aneto.',
  },
  en: {
    nav: {
      entorno: 'Surroundings',
      calidades: 'Qualities',
      pisoPiloto: 'Showhouse',
      disponibilidad: 'Availability',
      promotora: 'Developer',
      contacto: 'Contact',
      solicitarInfo: 'Request Information',
    },
    hero: {
      title: 'ANETO',
      subtitle: '109 new build homes in Tenerife South',
      desc: '32 townhouses, 77 apartments with 2 and 3 bedrooms, 3 commercial premises in Llano del Camello, Las Chafiras.',
      ctaPrimary: 'View available homes',
      ctaSecondary: 'Request information',
      indicators: [
        '109 homes',
        '2 and 3 bedrooms',
        'Garage and storage',
        'Heated 120m² pool',
        'Air conditioning installed',
        'Aerothermal system',
        'Built-in wardrobes',
        'A and B energy rating',
      ],
    },
    intro: {
      title: 'Your new home in South Tenerife',
      p1: 'Aneto has been conceived for those seeking quality of life, comfort, and a strategic location in the south of Tenerife.',
      p2: 'Located in Llano del Camello, next to Las Chafiras, it offers a unique combination of residential tranquility and proximity to all amenities.',
      map: 'View on Google Maps',
    },
    location: {
      title: 'Everything you need just minutes away',
      subtitle:
        '"An established residential enclave where you can go about your daily life without long commutes."',
      places: {
        school: 'Luther King School',
        mall: 'Gran Manzana Shopping Center',
        airport: 'Tenerife South Airport',
        cristianos: 'Los Cristianos',
        adeje: 'Costa Adeje',
        golf: 'Golf del Sur',
        medical: 'Medical Center',
        gym: 'Gyms',
        dogPark: 'Dog Park',
        culture: 'Cultural Center',
        sports: 'Sports Facilities',
        supermarket: 'Supermarkets',
      },
    },
    qualities: {
      title: 'Homes ready to enjoy from day one',
      subtitle:
        'Each home is delivered fully equipped with premium finishes, designed so you only have to worry about enjoying your new home.',
      items: [
        'Fully equipped kitchen',
        'Air conditioning installed',
        'Aerothermal system installed',
        'Built-in wardrobes',
        'Lighting installed',
        'Parking space',
        'Private storage room',
        'High-quality carpentry',
        'Thermal and acoustic insulation',
        'Blinds on every window and patio door',
      ],
    },
    amenities: {
      title: 'Aneto Show Home: experience it before you decide',
      subtitle:
        'Spaces designed to enjoy the Tenerife climate year-round, promoting well-being and community life.',
      features: {
        pool: {
          title: 'Heated pool',
          desc: 'Large 120m² communal pool heated by an aerothermal heat pump to enjoy all year round.',
        },
        solarium: {
          title: 'Spacious solarium',
          desc: 'Rest areas and sun loungers surrounding the pool with premium non-slip flooring.',
        },
        gardens: {
          title: 'Landscaped gardens',
          desc: 'Careful landscaping with low-water-consumption native species and ambient lighting.',
        },
        parking: {
          title: 'Garage and storage',
          desc: 'Spacious parking spaces and private storage rooms with pre-installation for electric vehicle charging.',
        },
      },
    },
    phases: {
      tag: 'Project phases',
      title: 'Availability by phases',
      status: {
        sold: 'COMPLETELY SOLD',
        available: 'HOMES AVAILABLE',
        soon: 'COMING SOON',
      },
      labels: {
        status: 'Status',
        delivery: 'Delivery',
      },
      buttons: {
        viewProject: 'View project',
        viewAvailable: 'View available homes',
        notify: 'Notify me of launch',
      },
      phases: {
        p1: { name: 'Phase 1', delivery: 'July 2026' },
        p2: { name: 'Phase 2', delivery: 'March 2027' },
        p3: { name: 'Phase 3', delivery: 'Early 2028' },
        p4: { name: 'Phase 4', delivery: 'Late 2028' },
      },
    },
    availability: {
      title: 'Choose your ideal home',
      subtitle:
        'Check available homes, their features, and prices. Download floor plans or request information without obligation.',
      filters: {
        all: 'All',
        apartments: 'Apartments',
        townhouses: 'Townhouses',
      },
      table: {
        type: 'Type',
        beds: 'Bedrooms',
        baths: 'Bathrooms',
        area: 'Built area',
        terrace: 'Terrace',
        price: 'Price',
        plans: 'Plans',
      },
      buttons: {
        viewPlan: 'View plan',
        reqPlan: 'Request plan',
      },
      empty: 'No homes match the selected filters.',
      modal: {
        unit: 'Home',
        close: 'Close plan',
      },
    },
    developer: {
      title: 'A track record that inspires trust',
      tabs: {
        promoter: 'Developer',
        architects: 'Architects',
        energy: 'Energy Rating A',
      },
      learnMore: 'LEARN MORE >',
      architect: {
        name: 'Francisco Javier Álvarez Muñoz',
        p1: 'Francisco Javier Álvarez Muñoz is an architect with professional activity in Tenerife, where he has developed residential, rehabilitation, and new build projects, both in the private and public sectors.',
        p2: 'His work focuses on contemporary and functional architecture, adapted to the island environment and with special attention to light, materials, and landscape integration.',
      },
      energy: {
        title: 'Energy rating',
        p1: 'The Aneto development has been designed with a firm commitment to energy efficiency and the comfort of its residents.',
        p2: 'The apartments have an Energy Rating B, while the townhouses achieve an Energy Rating A, ensuring lower energy consumption and a reduction in CO₂ emissions.',
        p3: 'All homes incorporate an individual aerothermal system for domestic hot water production, an efficient and environmentally friendly technology that uses energy from the air to reduce electricity consumption.',
        p4: 'Furthermore, the roofs of the townhouses are prepared for the future installation of photovoltaic panels, facilitating the incorporation of renewable energies and contributing to greater energy self-sufficiency.',
      },
      pibasa: {
        p1: 'With over three decades of experience in the real estate sector, PIBASA has participated in the development of residential, tourist, and hotel projects in both Huesca and Tenerife, consolidating a track record based on construction quality, corporate solvency, and the fulfillment of its commitments.',
        p2: 'Trust is one of the fundamental pillars of our activity. Therefore, the amounts delivered on account by buyers have the legally required guarantees and are backed by Banco Santander, one of the main financial institutions in Spain, offering maximum security throughout the purchasing process.',
      },
    },
    contact: {
      title: 'Request information',
      subtitle:
        'Leave us your details and our sales team will contact you as soon as possible to answer all your questions.',
      form: {
        name: 'Full name',
        email: 'Email address',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send message',
        sending: 'Sending...',
        success: 'Message sent successfully! We will contact you soon.',
        namePlaceholder: 'Your name',
        phonePlaceholder: '+34 600 000 000',
        emailPlaceholder: 'you@email.com',
        messagePlaceholder: 'How can we help you?',
        typeLabel: 'Type of home of interest',
        typePlaceholder: 'Select an option',
        options: {
          apt2: '2-bedroom apartments',
          apt3: '3-bedroom apartments',
          th2: '2-bedroom townhouses',
          th3: '3-bedroom townhouses',
        },
        rgpd: 'I have read and accept the privacy policy and the processing of my personal data to receive information about the development. *',
        submitBtn: 'I WANT TO RECEIVE INFORMATION',
        successTitle: 'Thank you for your interest!',
        successDesc:
          'We have received your request successfully. We will contact you very soon.',
      },
      info: {
        office: 'Sales office',
        address: 'C/ Cuescaro, 14, 38639, Las Chafiras, Santa Cruz de Tenerife',
        phone: 'Phone',
        email: 'Email',
        schedule: 'Schedule',
        hours: 'Monday to Friday: 9:00 - 18:00',
      },
    },
    footer: {
      desc: 'Exclusive new build homes in Llano del Camello, San Miguel de Abona, Tenerife South.',
      links: 'Quick links',
      legal: 'Legal',
      legalLinks: {
        notice: 'Legal Notice',
        privacy: 'Privacy Policy',
        cookies: 'Cookies Policy',
      },
      rights: 'Aneto Residencial. All rights reserved.',
      disclaimer: 'Images are indicative and non-contractual.',
    },
    whatsapp:
      'Hello, I would like to receive information about the Aneto residential development.',
  },
}

export type Language = 'es' | 'en'
export type Translations = typeof translations.es
